import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { STR_YES } from "../../../constants";
import {
    IOptionSingleValue,
    IOptionValue,
    IOptionValues,
} from "../../../models/catalogue";
import { useAppSelector } from "../../../store/reducers";
import { notEmpty } from "../../../utils/functional";
import { assertNever } from "../../../utils/never";
import { defaults } from "../defaults";
import { IPLCProductOptionSelector } from "../models";
import { getOptionValueByIdx } from "../utils";

type IProps = Immutable<{
    selectors: readonly IPLCProductOptionSelector[];
}>;

const getValue = (
    values: IOptionValues,
    selector: IPLCProductOptionSelector,
): IOptionValue | undefined => {
    switch (selector.type) {
        case "mattress_size":
            return values.option_size;
        case "mattress_feel":
            return values.option_feel;
        case "boolean_option_group":
            return selector.value.selectors
                .reduce<IOptionSingleValue[]>((memo, subSel) => {
                    const val = getOptionValueByIdx(
                        values[subSel.attribute],
                        0,
                    );
                    if (val === STR_YES) {
                        memo.push(subSel.name);
                    }
                    return memo;
                }, [])
                .join(", ");
        case "other":
            return values[selector.value.attribute];
    }
    throw assertNever(selector);
};

export const PLCProductOptionSelectorCurrentValue = (props: IProps) => {
    const optionValues = useAppSelector((rootState) => {
        const state = rootState.configurator || defaults;
        return state.ui.optionValues;
    });

    const values = props.selectors
        .map((selector) => {
            const rawValue = getValue(optionValues, selector);
            return getOptionValueByIdx(rawValue, 0);
        })
        .filter(notEmpty)
        .filter((val) => !!val);
    const text = values.length <= 0 ? t`Select…` : values.join(", ");
    return <>{text}</>;
};
